export const BOOKS_QUESTION_ICON_URL =
  'https://heard-images.s3.amazonaws.com/assets/books%20question.svg'
export const AI_ASSISTANT_ICON_URL =
  'https://heard-images.s3.amazonaws.com/assets/AI%20Assistant.svg'
